// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__22OB_","title":"Info_title__2Qg8W","selects":"Info_selects__2v6fl","requiredAsterisk":"Info_requiredAsterisk__1XrmN"};